import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-espresso">
      <img
        src="/kbl-logo-white.png"
        alt="Loading KBL Coffee"
        className="h-24 w-auto animate-soft-pulse object-contain md:h-28"
      />
    </div>
  );
};

export default LoadingSpinner;
